/* eslint-disable no-undef */
import React, { useState } from 'react';
import { Link } from '@inertiajs/react';
import Icon from '@/Shared/Icon';
import classNames from 'classnames';
import MainMenu from './MainMenu';

export const BottomHeader = ({ user, cart }) => {
	const [menuOpened, setMenuOpened] = useState(false);
	const is_wrap_group = user?.is_wrap_group ? user.is_wrap_group : false;

	const hamburgerNavLinkClasses = classNames(
		'block px-6 py-2 text-white hover:text-white header-menu-item font-bold border-b border-savrxBorderColor'
	);

	return (
		<div
			className={`flex text-center items-center w-full lg:gap-2 justify-end`}
		>
			{user && (
				<>
					<MainMenu
						className={
							menuOpened
								? 'hidden'
								: 'lg:flex hidden items-center text-center justify-between xl:justify-evenly w-full mx-2'
						}
					/>
					<div className="flex justify-end">
						<div className="relative">
							<div className="flex justify-end col-span-3 w-10 h-10 mx-2">
								<Link
									href={route('cart.index')}
									className="flex items-center hover:text-accent hover:outline"
								>
									<div className="flex">
										<div className={`cart-container w-10`}>
											<i className="cursor-pointer fa fa-2x fa-shopping-cart fill-current" />
										</div>
										<div
											className={`flex h-5 w-5 items-center justify-center rounded-full bg-accent text-white ${
												cart?.items && cart.items.total_count ? '' : ' hidden'
											}`}
										>
											<p>
												{cart?.items && cart.items.total_count
													? cart.items.total_count
													: 0}
											</p>
										</div>
									</div>
								</Link>
							</div>
						</div>
						<div className="flex items-center cursor-pointer select-none group">
							<div className="text-base sm:text-sm sm:mr-1 text-white whitespace-nowrap group-hover:text-indigo-600 focus:text-indigo-600 flex items-center">
								<span className="hidden xl:flex mr-1">
									Welcome, {user.first_name}!
								</span>
								<Icon
									className="hamburger-open w-10 h-10 text-white fill-current group-hover:text-accent focus:text-primary block lg:hidden cursor-pointer"
									name="hamburger"
									onClick={() => {
										setMenuOpened(true);
									}}
								/>
								<Icon
									className="hidden hamburger-close w-8 h-8 fill-current group-hover:text-indigo-600 focus:text-indigo-600 cursor-pointer pl-2"
									name="hamburger-x-close"
								/>
							</div>
						</div>
					</div>
					<div className={menuOpened ? '' : 'hidden'}>
						<div className="fixed left-0 sm:absolute sm:top-0 sm:right-2 sm:left-auto z-20 mt-6 sm:mt-16 text-base font-medium sm:font-normal sm:text-sm whitespace-nowrap bg-primary sm:rounded-md shadow-xl w-full sm:w-auto">
							<div className="px-6 py-2 border-b border-savrxBorderColor font-bold text-white sm:hidden">
								Welcome, {user.first_name}!
							</div>
							<Link
								href={route('dashboard.index')}
								className={hamburgerNavLinkClasses}
								onClick={() => setMenuOpened(false)}
							>
								Dashboard
							</Link>
							{!is_wrap_group && (
								<Link
									href={route('drug-lookup.index')}
									className={hamburgerNavLinkClasses}
									onClick={() => setMenuOpened(false)}
								>
									Drug Price Lookup
								</Link>
							)}
							<Link
								href={route('claims.index')}
								className={hamburgerNavLinkClasses}
								onClick={() => setMenuOpened(false)}
							>
								Claim History
							</Link>
							<Link
								href={route('patient-my-account.index')}
								className={hamburgerNavLinkClasses}
								onClick={() => setMenuOpened(false)}
							>
								My Account
							</Link>
							<Link
								href={route('contact.index')}
								className={hamburgerNavLinkClasses}
								onClick={() => setMenuOpened(false)}
							>
								Communications
							</Link>
							<Link
								href={route('logout.index')}
								className="block w-full px-6 py-2 text-center focus:outline-none border-b border-savrxBorderColor text-white hover:text-white font-bold sm:font-normal header-menu-item"
								onClick={() => setMenuOpened(false)}
							>
								Log Out
							</Link>
						</div>
						<div
							onClick={() => {
								setMenuOpened(false);
							}}
							className="fixed inset-0 z-10 bg-black opacity-0 sm:opacity-25"
						></div>
					</div>
				</>
			)}

			{!user && (
				<div className="relative flex sm:gap-2 sm:grid sm:grid-cols-2 sm:pt-2">
					<div>
						<Link
							href={route('quick-refill.index')}
							className="hidden flex sm:block px-1 py-1 border-2 border-transparent font-medium justify-center items-center sm:text-base hover:underline"
						>
							Mail Order Quick Refill
						</Link>
					</div>
					<div className="text-center">
						<Link
							href={route('login.index')}
							className="hidden flex sm:block px-1 py-1 border-2 border-black hover:bg-black hover:text-white font-medium justify-center items-center sm:text-base"
						>
							Log In
						</Link>
					</div>
					<div
						className="flex items-center cursor-pointer select-none group"
						onClick={() => {
							setMenuOpened(true);
						}}
					>
						<Icon
							className="hamburger-open w-8 h-8 fill-current group-hover:text-indigo-600 focus:text-indigo-600 block sm:hidden cursor-pointer"
							name="hamburger"
						/>
					</div>
					<div className={menuOpened ? '' : 'hidden'}>
						<div className="fixed sm:hidden left-0 z-20 py-2 mt-14 text-base font-medium whitespace-nowrap bg-white shadow-xl w-full text-black">
							<Link
								href={route('quick-refill.index')}
								className="block px-6 py-2 hover:bg-indigo-600 hover:text-white"
								onClick={() => setMenuOpened(false)}
							>
								Mail Order Quick Refill
							</Link>
							<Link
								as="button"
								href={route('login.index')}
								className="block w-full px-6 py-2 focus:outline-none hover:bg-indigo-600 hover:text-white font-medium sm:font-normal text-black"
								method="get"
							>
								Log In
							</Link>
						</div>
						<div
							onClick={() => {
								setMenuOpened(false);
							}}
							className="fixed inset-0 z-10 bg-black opacity-0 sm:opacity-25"
						></div>
					</div>
				</div>
			)}
		</div>
	);
};

export default BottomHeader;
